/**
 * Inspire-hub 2 (www.giap.pl)
 *
 * Copyright © GIAP sp.z.o.o. All rights reserved.
 *
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Written by Krzysztof Gregorowicz <gregorowicz.k@gmail.com>, February 2017
 */

import React, { PropTypes } from 'react';
import ServicesLayout from '../../components/ServicesLayout';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import s from './NotFound.css';
import sadFace from './lamington_sad.png';

class NotFound extends React.Component {
  static propTypes = {
    title: PropTypes.string.isRequired,
  };

  render() {
    return (
      <div className={s.root}>
        <div className={s.container}>
          {this.props.title ? <h1>{this.props.title}</h1> : null}
          <div className={s.napis}>Przepraszamy, nie znaleziono żądanego zasobu</div>
          {/*<div>
            <img className={s.sad} src={sadFace} alt="sadface" />
          </div>*/}
        </div>
      </div>
    );
  }
}

export default withStyles(s)(NotFound);



// WEBPACK FOOTER //
// src/routes/notFound/NotFound.js